import { styled } from "@mui/material/styles";
import { alpha, darken, DialogContent as MuiDialogContent, Grid, TableCell, Typography } from "@mui/material";
import { COLORS } from "src/_globalStore/redux/reducers/Theme/themeConstants";

export const ActionsCellContainer = styled(Grid)({
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  flexDirection: "row",
  justifyContent: "center",

  "& > .MuiButton-root": {
    width: "100px",
    height: "35px",
  },
});

export const LinkContainer = styled(Grid)({
  marginTop: "20px",
});

export const Link = styled(Typography)(({ theme }) => ({
  width: "fit-content",
  fontSize: "1.1em",
  lineHeight: "1.5",
  padding: "0 5px",
  color: "#606060",
  borderBottom: "1px solid #D3D3D3",
  textDecoration: "none",
  cursor: "pointer",
  transition: "all .1s ease",

  "&:hover": {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
  },
}));

export const ClientIconContainer = styled(Grid)({
  marginLeft: "5px",
  display: "inline-block",
});

export const DialogContent = styled(MuiDialogContent)({
  display: "flex",
  alignItems: "center",
  gap: "30px",
  margin: "0px",
  padding: "20px 10px",

  ".MuiButton-root": {
    height: "40px",
    fontSize: "1.3em",
    textTransform: "none",
  },
});

export const TextMessage = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  color: theme.palette.text.primary,
  fontWeight: "bold",
}));

export const Container = styled(Grid)(({ theme }) => ({
  overflow: "auto",
  // marginTop: "20px",
  "& .MuiTableHead-root": {
    "& .MuiTableRow-root": {
      height: "56px",
      "& .MuiTableCell-root": {
        backgroundColor: theme.palette.background.paper,
        "&:first-of-type": {
          borderRadius: "12px 0px 0px 12px",
          width: "25%",
        },
        "&:last-of-type": {
          borderRadius: "0px 12px 12px 0px",
        },
        "& .MuiTypography-root": {
          fontWeight: 500,
        },
      },
    },
  },

  "& .MuiTableRow-root": {
    "& .MuiTableCell-root": {
      borderBottom: `1px solid ${darken(COLORS.black_gradients.greyLight, 0.05)}`,

      "&:first-of-type": {
        textAlign: "center",
        padding: 0,
        width: "25%",
      },
      "&:not(:last-of-type)": {
        borderRight: `1px solid ${darken(COLORS.black_gradients.greyLight, 0.025)}`,
      },
    },
  },
}));

export const TableContainer = styled(Grid)({
  width: "100%",
  minWidth: "500px",
});

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "align" && prop !== "actionsWidth",
})<{ align?: "left" | "center" | "right"; width?: number; actionsWidth?: number }>(
  ({ width, theme }) => ({
    ...(!!width && {
      width: `${width}%`,
    }),
  }),
  ({ width, actionsWidth, theme }) => ({
    ...(width !== 0 &&
      !!actionsWidth && {
        width: `(100% - ${actionsWidth}px) / 100 * ${width}`,
      }),
    ...(width === 0 &&
      !!actionsWidth && {
        minWidth: `${actionsWidth}px`,
        maxWidth: `${actionsWidth}px`,
      }),
  }),
  ({ align, theme }) => ({
    ...(!!align && {
      textAlign: align,
    }),
  })
);
